/**
 * SessionRestored.contract.ts — OPERATOR IDENTITY™ Phase 1 (Build 2.06.0).
 * Published when a prior session is successfully restored (page refresh, browser restart).
 */

import type { EventContract } from '../EventContractRegistry';

export const SessionRestoredContract: EventContract = {
  name: 'SessionRestored',
  version: 1,
  description: 'Published when a prior session is successfully restored (page refresh, browser restart).',
  publishers: ['auth-event-service'],
  subscribers: [],
  fields: [
    { name: 'operatorId', type: 'number', required: true, description: 'Authenticated operator user ID' },
    { name: 'email', type: 'string', required: true, description: 'Operator email address' },
    { name: 'sessionAge', type: 'number', required: true, description: 'Approximate session age in ms' },
  ],
  allowExtraFields: false,
  timestampPolicy: 'Set to Date.now() at publish time.',
  stability: 'stable',
  deprecated: false,
  example: { operatorId: 1, email: 'roamer@example.com', sessionAge: 86400000 },
};
